import { Box, Grid } from '@mui/material'
import { FC, ReactNode } from 'react'
import { BodyText } from './BodyText';
import { SectionLabel } from './SectionLabel';

interface AgencyProfileSectionProps {
    title: string;
    description: string;
    content: ReactNode;
}

export const AgencyProfileSection: FC<AgencyProfileSectionProps> = ({ title, description, content }) => {
  return (
    <Grid container className="flex">
        <Grid item xs={4}>
            <Box className="flex flex-col space-y-2">
              <SectionLabel text={title} />
                <BodyText text={description} />
            </Box>
        </Grid>
        <Grid item xs={6}>{content}</Grid>
    </Grid>
  )
}
